export enum PrescriptionStatus {
  RETRYING = 'RETRYING',
  ERROR = 'ERROR',
  NOT_STARTED = 'NOT_STARTED',
  SENT = 'SENT',
  SENDING = 'SENDING',
  READY_TO_SEND = 'READY_TO_SEND',
  SENT_UNVALIDATED = 'SENT_UNVALIDATED',
  PENDING_EXTERNAL_SEND = 'PENDING_EXTERNAL_SEND',
  DELETED_EXTERNAL_BY_DOCTOR = 'DELETED_EXTERNAL_BY_DOCTOR',
  SEND_EXTERNAL = 'SEND_EXTERNAL'
}
